module.exports = __webpack_public_path__ + "img/timeline-02.c3bfb8db.jpg";